import React, { useMemo } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'
import { OrderItem } from '../../model-order'

export function ChangeItemQuantity(props: { onClose: () => void; onSave: (action: EditOrderAction) => void; cartItemId: number; cartItem: OrderItem }): JSX.Element {
  // const editOrderSvc = useEditOrderSvc()
  // const item = useMemo(() => editOrderSvc.getItem(props.cartItemId), [])
  const item = props.cartItem

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      quantity: item.quantity,
    },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    props.onSave({op: 'update-quantity', item_id: item.id, item_name: item.name, quantity: data.quantity, prev_quantity: item.quantity})
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Change {item.name} Quantity</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="quantity">Quantity:</label>
            <input
              id="quantity"
              className="form-control input input-small"
              style={errors && errors.quantity ? { color: 'red' } : {}}
              type="number"
              step={1}
              {...register('quantity', {
                required: 'is required',
                min: { value: 1, message: 'must be greater than 0' },
                valueAsNumber: true,
              })}
            />
            {errors && errors.quantity && <span className="text-danger">{errors.quantity.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">Save</Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
